import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { EntityIdAndPaginationParams } from '../../../shared/models/entity-id-and-pagination-params.model';
import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { PaginationDefaults } from '../../../shared/utils/pagination-defaults.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { VehicleReportDto } from '../dtos/vehicle-report.dto';
import { VehicleReportModel } from '../models/vehicle-report.model';
import { mapVehicleReportDtoToVehicleReportModel } from '../utils/mapping/mapping.util';

export const getCampaignReports: AsyncThunk<
  VehicleReportModel[],
  Partial<EntityIdAndPaginationParams>,
  Record<string, unknown>
> = withMandant<Partial<EntityIdAndPaginationParams>, VehicleReportModel[]>(
  Endpoints.GET_REPORTS_BY_CAMPAIGN,
  'get-campaign-reports',
  async ({ args, endpoint }) => {
    const pathParams = createPathParams<'campaignId'>(endpoint, {
      campaignId: args.entityId,
    });

    const queryParams = createQueryParams({
      size: args?.pagination?.size
        ? args.pagination.size
        : PaginationDefaults.size,
      offset: args?.pagination?.offset
        ? args.pagination.offset
        : PaginationDefaults.offset,
    });

    const { data }: AxiosResponse<VehicleReportDto[]> = await axiosInstance.get(
      pathParams + queryParams
    );

    return data.map(mapVehicleReportDtoToVehicleReportModel);
  }
);
